$('button.buy_btn.tt-bttnn.instagram-section').click(function(event){
     event.preventDefault()
    console.log('greet');
    
var ID = $(this).attr('gg-id');
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: ID
},
  dataType: 'json', 
 success: function (data) { 
  console.log('added');
     window.location.href = "/checkout";
 } 
 });
}) 
//accordian 
     $(".acc-head").click(function () {
            $(this).next().slideToggle(500), $(this).toggleClass("active");
        });
if($('.sub_category_child').find('.sub_cate-active').length !== 0){
    console.log('yes');
  $('.sub_category_child').hide();
}else{
    $('.sub_category_child').hide();
}

// linklist js
 $('.acnav__label').click(function () {
	var label = $(this);
	var parent = label.parent('.has-children');
	var list = label.siblings('.acnav__list');

	if ( parent.hasClass('is-open') ) {
    label.removeClass("icon-new");
		list.slideUp('200');
		parent.removeClass('is-open');
	}
	else {
     label.addClass("icon-new");
		list.slideDown('200');
		parent.addClass('is-open');
	}
});


$('.mediaimageholder').click(function() {
  // alert('fgfg');
 $('.tt-btn-zomm.tt-top-right.tt-btn-zomm-product-page').trigger( "click" );
});
// custom checkout card product btn JS
$('.pro_t').click(function() {
      var new_id = $(this).attr( "cd_id" );
      // alert(new_id);
    // $('.custom_crt_btn').trigger( "click" );
      // $('.btn.ttmodalbtn').trigger( "click" );
      
      $.ajax({    
     type: 'POST',
    url: '/cart/add.js',
    data: {
    quantity: 1,
    id: new_id
    },
   dataType: 'json', 
   success: function (data) { 
    window.location.href = "/checkout";
      } 
   });
      
      });

// custom checkout banner btn JS
$('.pro_t').click(function() {
      var new_id = $(this).attr( "cd_id" );
      // alert(new_id);
    // $('.custom_crt_btn').trigger( "click" );
      // $('.btn.ttmodalbtn').trigger( "click" );
      
      $.ajax({    
     type: 'POST',
    url: '/cart/add.js',
    data: {
    quantity: 1,
    id: new_id
    },
   dataType: 'json', 
   success: function (data) { 
    window.location.href = "/checkout";
      } 
   });
      
      });

// banner checkout btn JS
    $('.nt_btn').click(function() {
      var new_p = $(this).attr("pt-id");
      console.log(new_p);    
  $.ajax({    
    type: 'POST',
    url: '/cart/add.js',
    data: {
    quantity: 1,
    id: new_p
    },
   dataType: 'json', 
   success: function (data) { 
   window.location.href = "/checkout";
      } 
   });
      });
  
  $(".sub_category_child").each(function(){
    $(this).find('.sub_cate-active').parents('.has-children').addClass('is-open');
    $(this).find('.sub_cate-active').parent('.sub_category_child').show();
  });

// sort by js collection

$(".custom_sort_js > .sort-position").on("change", function(ev) {
  ev.preventDefault();
  //get current page url
  var sortby = $(this).val();
  
  // Check if page url does not contain ?sort_by
  if (window.location.href.indexOf('?sort_by=') === -1) {
    // If not present, add ?sort_by=sortby to the URL
    window.location.href += '?sort_by=' + sortby;
  } else {
    // If present, replace value of sortby in ?sort_by
    var newUrl = window.location.href.replace(/(\?|&)sort_by=([^&]*)/, '$1sort_by=' + sortby);
    window.location.href = newUrl;
  }
  
  // For debugging, you can use alert to check the new URL
  // alert(window.location.href);
});


//Product page testimonial

//   $('.testimonal-slider').slick({
//   infinite: true,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//     prevArrow:"<div class='pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='54' height='54' viewBox='0 0 54 54' fill='none'><path d='M31.5 15.75L20.25 27L31.5 38.25' stroke='#333333' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
//     nextArrow:"<div class='next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='54' height='54' viewBox='0 0 54 54' fill='none'><path d='M22.5 15.75L33.75 27L22.5 38.25' stroke='#333333' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
//        responsive: [
//     {
//       breakpoint: 990,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//       },
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//       },
//     },
//   ],
// });  
